const FETCH_TICKETS: string = 'tickets/fetchTickets';
const FETCH_STATS: string = 'tickets/fetchStats';
const DETAILS: string = 'tickets/details';

export default {
  FETCH_TICKETS,
  FETCH_STATS,
  DETAILS,
};
